import script from "./AddressFormsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressFormsModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddressFormsModal.vue?vue&type=style&index=0&id=54d4e7be&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d4e7be"]])

export default __exports__